import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CaddyIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Caddy`}
    {...props}
    testID="caddy-icon"
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.4 15v-4.2l2.1-5.25M5.5 5.55 2 6.6l1.75 2.1"
      fill="none"
    />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6.9 15-.35-2.8L4.1 9.05M5.5 5.55 7.25 7.3h3.85M9.35 15 11.1 1"
      fill="none"
    />
    <Circle cx={6.55} cy={2.75} r={1.75} fill="currentColor" />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m11.1 1 3.5 2.45-3.85 1.05"
      fill="none"
    />
  </Icon>
);
